"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 4.4c-1.936 0-3.518 1.587-3.518 3.56v2.839c0 .909-.408 1.771-1.114 2.344l-.217.176a.17.17 0 0 0-.064.094.2.2 0 0 0 .007.114.2.2 0 0 0 .063.091c.02.015.05.03.101.03h9.485a.16.16 0 0 0 .101-.03.2.2 0 0 0 .063-.09.2.2 0 0 0 .007-.115.17.17 0 0 0-.064-.094l-.218-.176a3.02 3.02 0 0 1-1.113-2.344v-2.84C13.519 5.987 11.937 4.4 10 4.4M5.082 7.96C5.082 5.225 7.278 3 10 3s4.919 2.226 4.919 4.96v2.839c0 .49.22.952.595 1.257m0 0 .218.176c1.144.928.511 2.816-.99 2.816H5.259c-1.5 0-2.133-1.888-.989-2.816l.217-.176c.376-.305.596-.767.596-1.257v-2.84M7.896 16.3a.7.7 0 0 1 .7-.7h2.81a.7.7 0 1 1 0 1.4h-2.81a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertIcon20.js.map